export enum Gender {
  Female,
  Male
}
